import { render, staticRenderFns } from "./LocalizedTime.vue?vue&type=template&id=7bddfcb7&"
import script from "./LocalizedTime.vue?vue&type=script&lang=js&"
export * from "./LocalizedTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports